import PropTypes from 'prop-types';
import React from 'react';
import useMedia from '../../../../../shared/hooks/useMedia';
import { MobileView } from './MobileView';
import { DesktopView } from './DesktopView';

export const ReliableReviewHeader = ({
    user,
    showBusinessBadge,
    reviewerIndustry,
    isRepeatBuyer,
    isCancelledOrder,
    countryCode,
    createdAt,
}) => {
    const isSmallScreen = useMedia();

    const commonProps = {
        user,
        showBusinessBadge,
        countryCode,
        createdAt,
        isCancelledOrder,
        isRepeatBuyer,
    };

    return isSmallScreen ? (
        <MobileView {...commonProps} />
    ) : (
        <DesktopView {...commonProps} reviewerIndustry={reviewerIndustry} />
    );
};

ReliableReviewHeader.propTypes = {
    user: PropTypes.shape({
        has_profile_photo: PropTypes.bool.isRequired,
        username: PropTypes.string.isRequired,
        profile_photo: PropTypes.string,
    }).isRequired,
    isBusiness: PropTypes.bool,
    isRepeatBuyer: PropTypes.bool.isRequired,
    isCancelledOrder: PropTypes.bool.isRequired,
    reviewerIndustry: PropTypes.array,
    countryCode: PropTypes.string,
};
